module.exports = __webpack_public_path__ + "img/science_thumbnail.a85a3581.jpg";